import { Spin } from "antd";
import { useEffect, useState } from "react";
import { getLoanPlans } from "../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { Images } from "../../../Controller";
import { useNavigate } from "react-router-dom";

const LoanRequest = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [loanSettings, setLoanSettings] = useState([]);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const getAllLoanplans = () => {
    setSpinner(true);
    getLoanPlans()
      .then((res) => {
        setLoanSettings(res.data.loan_plan);
      })
      .catch((err) => console.log(err))
      .finally(() => setSpinner(false));
  };

  useEffect(() => {
    dispatch(setselectedTab("301"));
    if (!memberServices.includes("301")) {
      navigate("/not-Available");
    } else {
      getAllLoanplans();
    }
  }, []);

  return (
    <>
      <p className="font-semibold text-xl">Loan Management</p>
      <Spin spinning={spinner}>
        {loanSettings && loanSettings.length !== 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            {loanSettings?.map((i, index) => {
              return (
                <div
                  key={index}
                  className="bg-white shadow-lg hover:shadow-2xl transition-all duration-300 rounded-2xl p-6 border border-gray-100 relative group"
                >
                  {/* Plan Header */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary/10">
                      <img
                        src={Images.circleShape}
                        alt="plan"
                        className="w-5 h-5"
                      />
                    </div>
                    <h2 className="text-lg font-semibold text-gray-800 capitalize">
                      {i.plan_name}
                    </h2>
                  </div>

                  {/* Plan Details */}
                  <div className="grid grid-cols-2 gap-y-3 gap-x-4 text-sm text-gray-600">
                    <div>
                      <p className="text-gray-400">Min Amount</p>
                      <p className="font-medium text-gray-800">
                        ₹ {i.min_amount}
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Max Amount</p>
                      <p className="font-medium text-gray-800">
                        ₹ {i.max_amount}
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Interest Rate</p>
                      <p className="font-medium text-green-600">
                        {i.interest_rate}%
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Late Penalty </p>
                      <p className="font-medium text-gray-800">
                        {i.late_penalty_percent} %
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Min Tenure</p>
                      <p className="font-medium text-gray-800">
                        {i.min_emi_months} Months
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Max Tenure</p>
                      <p className="font-medium text-gray-800">
                        {i.max_emi_months} Months
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      navigate("/loanCalculator", {
                        state: { planDetails: i },
                      });
                    }}
                    className="mt-6 w-full bg-primary text-white py-2 rounded-xl font-semibold hover:bg-black transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    Calculate EMI
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex justify-center items-center h-40 text-gray-400">
            No Plans Available
          </div>
        )}
      </Spin>
      {/* {isOpen && (
        <PayModal
          details={{
            benificiary_name: response.account_holder,
            benificiary_account: response.account_no,
            benificiary_ifsc: response.ifsc_code,
          }}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )} */}
    </>
  );
};

export default LoanRequest;
